import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import PageContainer from "../../components/layout/PageContainer";
import Header from "./components/Header/Header";
import ControlPanel from "./components/ControlPanel/ControlPanel";
import LecturesTable from "./components/LecturesTable/LecturesTable";
import Pagination from "./components/Pagination/Pagination";
import EmptyState from "./components/EmptyState/EmptyState";
import lecturesData from "./data.json";
import styles from "./LecturesPage.module.css";

const LecturesPage = () => {
	const { departmentId } = useParams();
	const [selectedSubject, setSelectedSubject] = useState("");
	const [searchQuery, setSearchQuery] = useState("");
	const [currentPage, setCurrentPage] = useState(1);

	const logsPerPage = 20;

	useEffect(() => {
		if (lecturesData.departmentSubjects.length === 1) {
			setSelectedSubject(lecturesData.departmentSubjects[0].id);
		} else if (lecturesData.departmentSubjects.length > 0) {
			setSelectedSubject(lecturesData.departmentSubjects[0].id);
		}
	}, []);

	const filteredLectures = lecturesData.lectures.filter((lecture) => {
		const matchesSubject =
			!selectedSubject || lecture.subjectId === selectedSubject;
		const matchesSearch =
			!searchQuery ||
			lecture.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
			lecture.subjectName.toLowerCase().includes(searchQuery.toLowerCase());

		return matchesSubject && matchesSearch;
	});

	const sortedLectures = [...filteredLectures].sort((a, b) => {
		return new Date(b.date) - new Date(a.date);
	});

	const indexOfLastLog = currentPage * logsPerPage;
	const indexOfFirstLog = indexOfLastLog - logsPerPage;
	const currentLogs = sortedLectures.slice(indexOfFirstLog, indexOfLastLog);
	const totalPages = Math.ceil(sortedLectures.length / logsPerPage);

	const selectedSubjectName = lecturesData.departmentSubjects.find(
		(subject) => subject.id === selectedSubject
	)?.name;

	const handlePageChange = (pageNumber) => {
		setCurrentPage(pageNumber);
	};

	const handleLogClass = () => {
		console.log("Open log class modal");
	};

	const handleEditLecture = (lectureId) => {
		console.log("Edit lecture:", lectureId);
	};

	const handleDeleteLecture = (lectureId) => {
		if (window.confirm("Are you sure you want to delete this lecture?")) {
			console.log("Delete lecture:", lectureId);
		}
	};

	const formatDate = (dateString) => {
		const options = { year: "numeric", month: "short", day: "numeric" };
		return new Date(dateString).toLocaleDateString(undefined, options);
	};

	const clearSearch = () => {
		setSearchQuery("");
	};

	return (
		<PageContainer className={styles.lecturesPage}>
			<Header selectedSubjectName={selectedSubjectName} />

			<ControlPanel
				departmentSubjects={lecturesData.departmentSubjects}
				selectedSubject={selectedSubject}
				setSelectedSubject={setSelectedSubject}
				searchQuery={searchQuery}
				setSearchQuery={setSearchQuery}
				clearSearch={clearSearch}
				handleLogClass={handleLogClass}
			/>

			<div className={styles.content}>
				{sortedLectures.length > 0 ? (
					<>
						<LecturesTable
							currentLogs={currentLogs}
							formatDate={formatDate}
							handleEditLecture={handleEditLecture}
							handleDeleteLecture={handleDeleteLecture}
						/>

						<Pagination
							currentPage={currentPage}
							totalPages={totalPages}
							indexOfFirstLog={indexOfFirstLog}
							indexOfLastLog={indexOfLastLog}
							totalLectures={sortedLectures.length}
							handlePageChange={handlePageChange}
						/>
					</>
				) : (
					<EmptyState searchQuery={searchQuery} clearSearch={clearSearch} />
				)}
			</div>
		</PageContainer>
	);
};

export default LecturesPage;
